import { render, staticRenderFns } from "./GroupOfIndividualsRegistration.vue?vue&type=template&id=7bf0ca52&scoped=true"
import script from "./GroupOfIndividualsRegistration.vue?vue&type=script&lang=js"
export * from "./GroupOfIndividualsRegistration.vue?vue&type=script&lang=js"
import style0 from "./GroupOfIndividualsRegistration.vue?vue&type=style&index=0&id=7bf0ca52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0ca52",
  null
  
)

export default component.exports